export const apiRoutes = {
    dashboard: {
        info: '/dashboard/info',
    },
}